import { createAction } from '@ngrx/store';

// reportAppLaunchEvent -----------------------------------------------------------------
export const commonIdReportAppLaunchEvent = createAction('[CommonIdEventLog] Common Id Report App Launch Event');
export const commonIdReportAppLaunchEventSuccess = createAction('[CommonIdEventLog] Common Id Report App Launch Event Success');
export const commonIdReportAppLaunchEventFailure = createAction('[CommonIdEventLog] Common Id Report App Launch Event Failure');
